import React, {useEffect} from "react";
import { useForm } from 'react-hook-form';

// components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Spinner
} from "reactstrap";
import Select from 'react-select'

// services
import { removeAllCookies } from "services/cookies.js";
import { showMessage } from "services/message.js";
import { api_GET, api_GET_Login, api_POST_Login, api_PUT_Login } from "services/api_service.js";
import { setSessionCookie, setTokenCookie} from "services/session.js";

export default function Login({ history }) {

  const { register, handleSubmit } = useForm({ mode: "onBlur" });

  const[loading, set_loading] = React.useState(false);

  useEffect(() => {
    removeAllCookies();
    localStorage.clear();
  }, []);

  const [primeiroAcesso, setPrimeiroAcesso] = React.useState(false);

  const handleLogin = (event) => {
    setModulo(null);
    setSelectModulo(0);
    if (event.target.value == "")
    {
      setPrimeiroAcesso(false);
      return;
    }

    set_loading(true);
    api_GET_Login(`usuario/primeiroacesso/${event.target.value}`).then(result => {
      set_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else{
        setPrimeiroAcesso(result.data);
      }
    });
  }

  const [selectModulo, setSelectModulo] = React.useState(0);
  const [modulos] = React.useState([{label: "Gestor", value: "Gestor"}, {label:"Concessionária", value: "Concessionária"}, {label: "Encarregado de Monitoramento", value: "Encarregado de Monitoramento"}]);  
  const [modulo, setModulo] = React.useState(null);

  useEffect(() => {
    if(modulo == "Concessionária")
    {
      loadOptionsConcessionaria();
      setSelectModulo(2);
    }
    else if (modulo == "Gestor" || modulo == "Encarregado de Monitoramento")
      setSelectModulo(1);
  }, [modulo]);

  const [optionsConcessionaria, setOptionsConcessionaria] = React.useState([]);
  const [concessionaria, setConcessionaria] = React.useState(null);
  const loadOptionsConcessionaria = () => {
      api_GET(`concessionaria`).then(result => {            
          if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
          }
          else{
              setOptionsConcessionaria(result.data);                                              
          }
        });
  }

  const onSubmit = (data) => {
    if (loading)
      return;

    if (data.login == ""){
      showMessage("Atenção", "Informe o login para acessar o sistema!", 'warning' , null);
      return;
    }

    if (data.senha == ""){
      showMessage("Atenção", "Informe a senha para acessar o sistema!", 'warning' , null);
      return;
    }

    if (primeiroAcesso){
      if (data.novaSenha == "" || data.confirmarSenha == ""){
        showMessage("Atenção", "Informe a nova senha e a confirmação da nova senha!", 'warning' , null);        
        return;
      }

      if (data.novaSenha.length < 5){
        showMessage("Atenção", "Informe uma senha com pelo menos 5 dígitos!", 'warning' , null);        
        return;
      }

      if (data.novaSenha != data.confirmarSenha)
      {
        showMessage("Atenção", "A confirmação da senha não confere com a nova senha!", 'warning' , null);        
        return;
      }

      let jsonSubmit = {
        login: data.login,
        password: data.novaSenha,
        password_antiga: ""
      }

      set_loading(true);
      api_PUT_Login(`usuario/alterarsenha/`, jsonSubmit).then(result => {
        set_loading(false);
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else{
          setPrimeiroAcesso(false);
        }
      });      
    }
    else{
      let jsonSubmit = {
        login: data.login,
        password: data.senha
      }

      set_loading(true);
      api_POST_Login(`usuario/authenticate/`, jsonSubmit).then(result => {
        set_loading(false);
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);          
        }
        else if (result.data == null){
          showMessage("Aviso", "Usuário/Senha não encontrado", 'warning', null);
        }
        else if (result.data.usuario.perfil == "Master"){
          var token = {
            accessToken: result.data.accessToken,
            expiration: result.data.expiration        
          }
    
          setTokenCookie(token);

          let usuario = result.data.usuario;
          if (usuario.perfil == "Master")
          {
            if (selectModulo == 0){
              setSelectModulo(1);
            }
            else if (modulo == null){
              showMessage("Aviso", "Selecione o módulo", 'warning', null);
              return;
            }
            else if (modulo == "Concessionária" && concessionaria == null){
              showMessage("Aviso", "Selecione a concessionária", 'warning', null);
              return;
            }
            else{
              if (modulo == "Concessionária")
              {
                usuario.concessionariaId = concessionaria.concessionariaId;
                usuario.route = "concessionaria";
                setSessionCookie(usuario);
                history.push("/concessionaria/home");
              }              
              else if (modulo == "Gestor")
              {
                usuario.route = "admin";
                setSessionCookie(usuario);
                history.push("/admin/home");
              }
              else if (modulo == "Operador de Coleta")
              {
                usuario.route = "operador";
                setSessionCookie(usuario);
                history.push("/operador/trocarsenha");
              }
              else
              {
                usuario.route = "fiscal";
                setSessionCookie(usuario);
                history.push("/fiscal/home");
              }
            }
          }
        }
        else{
          var token = {
            accessToken: result.data.accessToken,
            expiration: result.data.expiration        
          }
    
          setTokenCookie(token);
          
          let usuario = result.data.usuario;
          if (usuario.perfil == "Gestor")
          {
            usuario.route = "admin";
            setSessionCookie(usuario);
            history.push("/admin/dashboard");
          }
          else if (usuario.perfil == "Adm" || usuario.perfil == "Supervisor")
          {
            usuario.route = "concessionaria";
            setSessionCookie(usuario);
            history.push("/concessionaria/dashboard");
          }
          else if (usuario.perfil == "Encarregado de Monitoramento")
          {
            usuario.route = "fiscal";
            setSessionCookie(usuario);
            history.push("/fiscal/dashboard");
          }
          else if (usuario.perfil == "Operador de Coleta")
          {
            usuario.route = "operador";
            setSessionCookie(usuario);
            history.push("/operador/trocarsenha");
          }
          else
            showMessage("Aviso", "Seu usuário não tem acesso ao Sistema Web", 'warning', null);
        }
      });      
    }        
  };

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-5">
            <div className="text-muted text-center mt-2 mb-3">
              <strong>Realize o Login</strong>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-single-02" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder="Login" type="text" name="login" onBlur={handleLogin} innerRef={register({ required: true })}/>
                </InputGroup>
              </FormGroup>
              {!primeiroAcesso &&
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Senha" type="password" name="senha" innerRef={register()}/>
                  </InputGroup>                
                </FormGroup>
              }
              {primeiroAcesso && 
                <div>
                  <FormGroup>                
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="Nova Senha" type="password" name="novaSenha" innerRef={register()}/>
                    </InputGroup>                
                  </FormGroup>
                  <FormGroup>                
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Confirmar Senha" type="password" name="confirmarSenha" innerRef={register()}/>
                  </InputGroup>                
                </FormGroup>
                </div>
              }
              {selectModulo != 0 && 
                <FormGroup>
                    <Select
                        options={modulos}
                        name="modulo"
                        onChange={(e) => {setModulo(e.value)}}
                        value={modulos.find(obj => obj.value === modulo)}
                        placeholder="Selecione o Módulo"
                    />                                      
                </FormGroup>
              }
              {selectModulo == 2 &&
                <FormGroup>
                  <Select
                      options={optionsConcessionaria}
                      name="concessionaria"
                      getOptionLabel={({identificacao}) => identificacao}
                      getOptionValue={({concessionariaId}) => concessionariaId} 
                      onChange={(value) => {setConcessionaria(value)}}
                      value={concessionaria != null && optionsConcessionaria.find(obj => obj.concessionariaId === concessionaria.concessionariaId)}
                      placeholder="Selecione a Concessionária"                                                                                                                         
                      
                  />                
                </FormGroup>
              }
              <div className="text-center">
                {primeiroAcesso &&
                  <Button className="my-4" color="primary" type="submit">
                    {loading && <Spinner size="sm" color="secondary" />} 
                    &nbsp; Confirmar &nbsp;
                  </Button>
                }
                {!primeiroAcesso &&
                  <Button className="my-4" color="primary" type="submit">
                    {loading && <Spinner size="sm" color="secondary" />} 
                    &nbsp; Entrar &nbsp;
                  </Button>
                }
              </div>
            </form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              className="text-light"
              style={{cursor:"pointer"}}
              onClick={() => {history.push("/auth/esqueceusenha");}}
            >
              <small>Esqueceu a Senha?</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
}
